/* eslint-disable no-console */
/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import CustomInput from "../../../Core/Components/CustomInput";
import Button from "../../../Core/Components/CustomButton";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import { client } from "../../../Utils/axiosClient";
import { updateRental } from "../../../Redux/Slices/rentals.slice";
import AlertIcon from "../../../Common/Svgs/AlertIcon";
// import { DEFAULT_LIMIT } from "../../../Utils/constants";
// import { getTrikesKPI, getTrikesV3 } from "../../../Redux/APIs/trikesAPI";

const ColumnHeader = () => {
  return (
    <div className="flex items-center border-b-[0.5px] border-light-grey">
      {["Registration no.", "Hub Station", "Start Energy"].map((item) => (
        <div key={item} className="flex-1 px-6 py-3 bg-background">
          <p className="font-aileron text-10 font-normal text-dark-gray">
            {item}
          </p>
        </div>
      ))}
    </div>
  );
};

const TrikeDispatchModal = ({ visible, onCancel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trikeDispatchModal } = useSelector((state) => state.trikes);
  const { allBatteries } = useSelector((state) => state.batteries);

  const [batteries, setBatteries] = useState([]);
  const [errors, setErrors] = useState([]);
  const [overallError, setOverallError] = useState("");

  const selectedIds = batteries
    ?.filter((item) => item.selected)
    ?.map((i) => i?.id);

  // filter the batteries based on the selected trike's hub id
  const getBatteries = useCallback(() => {
    const local = allBatteries
      ?.filter((item) => +item.currentHubId == trikeDispatchModal?.trike?.hubId)
      ?.map((i) => ({
        id: i.id,
        registrationNo: i.registrationNo,
        currentHubId: i.currentHubId,
        currentHubName: i.currentHubName,
        energy: i?.capacity ? i?.capacity : "",
        focus: false,
        selected: false,
      }));

    setBatteries(local);
  }, [allBatteries, trikeDispatchModal]);

  // to select the batteries
  const handleSelection = (id) => {
    const local = batteries.map((item) => {
      return {
        ...item,
        selected: item.id === id ? !item.selected : item.selected,
      };
    });

    setBatteries(local);
    setOverallError("");
  };

  // handing the energy percent
  const handleEnergy = (e, id) => {
    setBatteries((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, energy: e.target.value } : item,
      ),
    );

    const currentErrors = errors.filter((item) => item !== id);
    setErrors(currentErrors);
    setOverallError("");
  };

  // focus when entering end energy
  const handleFocus = (id, focus) => {
    setBatteries((prev) =>
      prev.map((item) => (item.id === id ? { ...item, focus } : item)),
    );
  };

  // clear states and close the modal
  const handleCancel = () => {
    setBatteries([]);
    setErrors([]);
    onCancel();
  };

  // check if the battery is selected
  // check if battery is selected but energy is not added
  const checkErrors = () => {
    if (!batteries.some((item) => item.selected)) {
      setOverallError("Please select atleast one battery");
      return true;
    }

    const errorIds = batteries
      .filter((item) => item.selected && !item.energy)
      .map((item) => item.id);

    if (errorIds.length > 0) {
      setErrors(errorIds);
      setOverallError("Please enter start energy");
      return true;
    }

    return false;
  };

  // API call to dispatch
  const handleConfirm = async () => {
    const hasError = checkErrors();

    if (hasError) return;

    const payload = {
      trikeId: trikeDispatchModal?.trike?.id,
      trikeRegistrationNo: trikeDispatchModal?.trike?.registrationNo,
      batteries: batteries.filter((item) => item.selected),
    };

    try {
      dispatch(updateTrikes({ key: "loading", value: true }));

      await client.post(
        `${process.env.REACT_APP_API_URL}/rentals/dispatch`,
        payload,
      );

      navigate("/rentals");

      dispatch(
        updateRental({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "1 Trike Dispatched.",
              description: `Trike ${payload?.trikeRegistrationNo} was dispatched successfully.`,
            },
          },
        }),
      );
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateTrikes({ key: "loading", value: false }));
      handleCancel();
    }
  };

  useEffect(() => {
    getBatteries();
  }, [getBatteries]);

  return (
    <CustomModal visible={visible} onCancel={handleCancel} width="1121px">
      <div
        className="py-4"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="px-4 flex items-center justify-between">
          <div className="flex items-center gap-x-3">
            <div className="flex items-center justify-center w-12 h-12 bg-green rounded-full">
              <ChargerIcon size={24} className="text-yellow" />
            </div>

            <p className="font-poppins text-base font-medium">
              Add Battery Energy
            </p>
          </div>

          <button type="button" onClick={handleCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {!batteries.length ? (
          <div className="mt-6 px-6">
            <p className="font-aileron font-semibold text-sm">
              No batteries available at the hub station.
            </p>
          </div>
        ) : (
          <div>
            <div className="max-h-[450px] overflow-y-scroll">
              <div className="mt-6">
                <p className="px-4 font-poppins font-medium text-xs">
                  Enter energy levels of the batteries
                </p>

                <p className="mt-1 mb-6 px-4 font-aileron font-normal text-xs text-dark-gray">
                  Record the energy consumed by the batteries for calculating
                  energy total revenue generation.
                </p>

                <ColumnHeader type="default" />

                {batteries.map((item) => {
                  const isChecked = selectedIds.includes(item.id);
                  const hasError = isChecked && errors.includes(item.id);

                  let border;
                  if (hasError) {
                    border = "error";
                  } else if (item.focus) {
                    border = "success";
                  } else {
                    border = "primary";
                  }

                  return (
                    <div
                      key={item.id}
                      className="flex items-center py-2 h-12 border-b-[0.5px] border-light-grey"
                    >
                      <div className="flex-1 pl-6 flex items-center gap-x-3">
                        <Checkbox
                          checked={isChecked}
                          onChange={() => handleSelection(item.id)}
                        />

                        <p className="flex-1 font-aileron text-xs font-semibold text-black">
                          {item.registrationNo}
                        </p>
                      </div>

                      <p className="flex-1 px-6 font-aileron text-xs font-semibold text-black capitalize">
                        {item.currentHubName}
                      </p>

                      <div className="flex-1 flex flex-col px-6">
                        <div className="flex-1 flex items-center">
                          <CustomInput
                            intent="editCommodity"
                            text="generalSettings"
                            value={item?.energy || ""}
                            focus={item.focus}
                            // border={item.focus ? "success" : "primary"}
                            border={border}
                            placeholder={item.focus ? null : "Energy"}
                            onChange={(e) => handleEnergy(e, item.id)}
                            onFocus={() => handleFocus(item.id, true)}
                            onBlur={() => handleFocus(item.id, false)}
                          />

                          <p className="ml-2 flex-1 font-aileron font-semibold text-xs text-dark-gray capitalize">
                            kWh
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="px-4 mt-6 flex items-center justify-between">
              {overallError ? (
                <div className="flex items-center gap-x-2">
                  <AlertIcon className="text-alert-red" />
                  <p className="font-aileron font-semibold text-xs text-alert-red">
                    {overallError}
                  </p>
                </div>
              ) : (
                <div />
              )}

              <div className="flex items-center gap-x-2">
                <Button
                  size="filter"
                  width="dynamic"
                  colors="grey"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>

                <Button
                  size="filter"
                  width="dynamic"
                  type="submit"
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default TrikeDispatchModal;
